import React from "react";
import SkeletonBox from "./skeleton";

const AssetpageSkeleton = () => {
    const renderSkeletonPairs = (pairs: string[][]) =>
        pairs.map((pair, idx) => (
            <div
                key={idx}
                className="mt-8 flex flex-row justify-between gap-2 md:flex-row md:gap-20"
            >
                <SkeletonBox classname={`${pair[0]} rounded-full`} />
                <SkeletonBox classname={`${pair[1]} rounded-full`} />
            </div>
        ));

    const renderGridSections = (count: number) =>
        Array.from({ length: count }).map((_, idx) => (
            <div key={idx} className="item mt-6 flex flex-col">
                <SkeletonBox classname="h-[16px] w-[110px] rounded-full" />
                <SkeletonBox classname="h-[27px] w-[141px] rounded-full mt-1" />
            </div>
        ));

    return (
        <div className="mx-auto h-auto w-full self-start px-6 md:w-[1280px]">
            <div className="w-full pb-4 pt-6 md:pb-10 md:pt-10">
                <SkeletonBox classname="w-full h-[54.41px] rounded-lg" />
            </div>

            <div className="flex flex-col items-start gap-3 pb-4 pt-6 md:flex-row md:items-center md:gap-3 md:pb-10 md:pt-10">
                <SkeletonBox classname="h-[64px] w-[64px] rounded-lg" />
                <SkeletonBox classname="h-[37px] md:w-[607px] w-[320px] rounded-full" />
            </div>

            <div className="flex flex-col gap-8 px-0 md:flex-row md:gap-16 md:py-s9 md:px-0 md:pb-10 md:pt-10">
                <div className="h-[553px] w-full rounded-3xl border border-gray-200 p-s9 md:w-[812px]">
                    <div className="flex flex-col gap-4 md:flex-row md:gap-80">
                        <SkeletonBox classname="h-[37px] md:w-[324px] rounded-full" />
                        <SkeletonBox classname="h-[37px] w-[95px] rounded-full" />
                    </div>
                    <div className="mt-96 flex justify-center gap-4 md:mt-96 md:flex-wrap md:gap-8">
                        {[...Array(5)].map((_, idx) => (
                            <SkeletonBox key={idx} classname="h-[37px] w-[56px] rounded-full" />
                        ))}
                    </div>
                </div>

                <div className="flex w-full flex-col gap-4 md:w-[299px]">
                    <div className="h-auto rounded-3xl border border-gray-200 p-s9">
                        <SkeletonBox classname="h-[25px] w-[210px] rounded-full" />
                        <div className="mt-4 border-b border-dotted border-gray-400" />
                        {renderSkeletonPairs([
                            ["h-[13px] w-[111px]", "h-[13px] w-[64px]"],
                            ["h-[13px] w-[142px]", "h-[13px] w-[64px]"],
                            ["h-[13px] w-[111px]", "h-[13px] w-[64px]"],
                            ["h-[13px] w-[111px]", "h-[13px] w-[64px]"],
                        ])}
                        <div className="mt-8 border-b border-dotted border-gray-400" />
                        <div className="mt-8 flex flex-row justify-between gap-2 md:gap-20">
                            <SkeletonBox classname="h-[13px] w-[111px] rounded-full" />
                            <SkeletonBox classname="h-[13px] w-[64px] rounded-full" />
                        </div>
                        <SkeletonBox classname="h-[49px] w-[255px] rounded-full mt-4 text-center" />
                    </div>

                    <div className="h-auto rounded-xl border border-gray-200 p-4">
                        <div className="flex flex-row items-center justify-between gap-4 md:gap-6">
                            <SkeletonBox classname="h-[20px] w-[140px] rounded-full" />
                            {[...Array(2)].map((_, idx) => (
                                <SkeletonBox key={idx} classname="h-[36px] w-[36px] rounded-full" />
                            ))}
                        </div>
                    </div>
                </div>
            </div>

            {/* Section 3 */}
            <div className="flex flex-col gap-4 p-s9 pl-0 pr-0 md:flex-row md:gap-4 md:py-0 md:pb-10">
                <div className="h-auto w-full rounded-3xl border border-gray-200 p-s9 md:w-[812px]">
                    <div className="item flex flex-row justify-between gap-2">
                        <SkeletonBox classname="h-[17px] w-[88px] rounded-full" />
                        <SkeletonBox classname="h-[17px] w-[52px] rounded-full" />
                    </div>
                    <div className="mt-4 border-b border-dotted border-gray-400" />
                    <SkeletonBox classname="h-[10px] w-[143px] rounded-full mt-8" />
                    <div className="item flex flex-col justify-between gap-2 md:flex-row">
                        <SkeletonBox classname="h-[23px] md:w-[468px] w-[200px] rounded-full mt-2 text-center" />
                        <SkeletonBox classname="h-[37px] w-[132px] rounded-full mt-2" />
                    </div>
                    <SkeletonBox classname="hidden md:block h-[10px] w-[143px] rounded-full" />
                </div>
            </div>

            {/* Section 4 */}
            <div className="flex flex-col gap-4 md:flex-row md:gap-4 md:py-0 md:pb-10 md:pt-10">
                <div className="h-auto w-full p-s9 md:w-[812px] px-0 py-0">
                 <div className="hidden md:block">  
                    <div className="item flex flex-wrap justify-between gap-2 md:gap-0">
                        {[...Array(5)].map((_, idx) => (
                            <SkeletonBox key={idx} classname="h-[17px] w-[100px] rounded-full" />
                        ))}
                    </div>
                    <div className="item mt-2 flex flex-wrap justify-between gap-2 md:gap-0">
                        {[
                            "w-[119px]",
                            "w-[119px]",
                            "w-[119px]",
                            "w-[190px]",
                            "w-[70px]",
                            "w-[70px]",
                        ].map((width, idx) => (
                            <SkeletonBox key={idx} classname={`h-[4px] ${width} rounded-full`} />
                        ))}
                    </div>
                    </div> 
                    <SkeletonBox classname="h-[32px] w-[193px] rounded-full mt-12" />
                    {[...Array(3)].map((_, idx) => (
                        <div key={idx} className="grid grid-cols-2 gap-4 md:flex md:flex-row md:justify-between">
                            {renderGridSections(3)}
                        </div>
                    ))}
                </div>
            </div>

            {/* Section 5 */}
            <div className="flex flex-col gap-4 p-s9 md:flex-row md:gap-4 md:py-0 md:pb-4 md:pt-10 pr-0 pl-0">
                <div className="h-auto w-full p-s9 md:w-[812px] pr-0 pl-0">
                    <div className="item flex justify-between gap-4 flex-row">
                        <SkeletonBox classname="md:h-[32px] md:w-[193px] h-[20px] w-[90px] rounded-full" />
                        <SkeletonBox classname="md:h-[36px] md:w-[250px] h-[20px] w-[90px] rounded-full" />
                    </div>
                </div>
            </div>
        </div>
    );
};

export default AssetpageSkeleton;
